import React, { useState, useEffect } from "react";
import { Image } from "antd";
import httpclient from "../../httpclient";
import IsEmpty from "../../helpers/IsEmpty";

const PreviewImage = ({ visible, setVisible, url }) => {
  const [src, setSrc] = useState("");
  const [muiltiSrc, setMultiSrc] = useState([]);

  useEffect(() => {
    if (!IsEmpty(url)) {
      if (typeof url === "string") {
        getImageUrl();
      } else if (typeof url === "object") {
        url.length > 0 && url.map((item) => getMultiImageUrl(item.pictureURL));
      }
    }
  }, [url]);

  const getImageUrl = async () => {
    setSrc("");
    await httpclient
      .GET(`${process.env.REACT_APP_BASE_API_URL}${url}`)
      .then((response) => {
        setSrc(response.data.data);
      })
      .catch(() => setSrc(""));
  };

  const getMultiImageUrl = async (urls) => {
    setMultiSrc([]);
    await httpclient
      .GET(`${process.env.REACT_APP_BASE_API_URL}${urls}`)
      .then((response) => {
        setMultiSrc((prev) => [...prev, response.data.data]);
      })
      .catch(() => setMultiSrc([]));
  };

  return (
    <>
      {typeof url === "string" ? (
        <Image
          width={200}
          style={{ display: "none" }}
          preview={{
            visible: visible,
            src: src,
            onVisibleChange: (value) => {
              setVisible(value);
            },
          }}
          onError={(event) =>
            (event.target.src = `${process.env.REACT_APP_PUBLIC_URL}images/placeholder.png`)
          }
        />
      ) : (
        <Image.PreviewGroup
          preview={{ visible, onVisibleChange: (vis) => setVisible(vis) }}
        >
          {Boolean(muiltiSrc.length) &&
            muiltiSrc.map((item) => {
              return (
                <Image src={item} width={200} style={{ display: "none" }} />
              );
            })}
        </Image.PreviewGroup>
      )}
    </>
  );
};

export default PreviewImage;
